import React, { Component } from "react";
import { connect } from "react-redux";
import { message, Tabs, Select } from "antd";
import { Button, CircularProgress } from "@material-ui/core";
import { ROLES, warehouseId } from "../../constants";
import { getOrderDetailsThunk } from "../../redux/NewOrderDetails/action";
import { getOrderIDScanThunk } from "../../redux/ScannerRedux/Action";
import {
  CustomField,
  MakerWrapper,
  OrderWrapper,
} from "../MarkOrder/MarkOrder.style";
import UserGreeting from "../../components/UserGreeting/UserGreeting";
import TitleWrapper from "../../components/TitleWrap/TitleWrap";
import OfflinePage from "../OfflinePage/OfflinePage";
import { withRouter } from "react-router-dom";

export class DisPacker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderNo: null,
      loaderStatus: false,
      dialogToggle: false,
      packageId: null,
      digits: null,
      enteredId: null,
      selectedOption: "box_Id",
      options: [
        {
          value: "box_Id",
          label: "Box ID",
        },
        {
          value: "order_Id",
          label: "Order ID",
        },
      ],
    };
    //Created a Ref for Enter Box or Order Id number
    this.enteredId = React.createRef(null);
  }
  detailsHandler = (reload = false) => {
    //set loader true when the form is submitted
    this.setState({
      loaderStatus: true,
    });
    if (!reload) {
      message.loading("Loading...", 0);
    }
    // if The value that is entered is empty
    if (!this.state.enteredId) {
      message.destroy();

      this.setState({
        digits: null,
        loaderStatus: false,
      });
      this.enteredId.current.focus();
      message.error("Enter Valid Details", 2);
      return;
    }
    this.setState({
      orderNo: this.state.orderId,
      // showScannerScreen: true,
    });
    if (this.state.selectedOption === "order_Id") {
      // Get Order Id based on the box number that you've entered
      this.props
        .getOrderIDScanThunk({
          access_token: this.props.access_token,
          warehouseId: warehouseId,
          boxNumber: this.state.enteredId,
          history: this.props.history,
        })
        .then(() => {
          message.destroy();
          this.setState({
            digits: null,
            loaderStatus: false,
          });
          if (this.props.boxNumber.scannedOrderIDOrderError) {
            message.error(this.props.boxNumber.scannedOrderIDOrderError);
          } else {
            this.setState({
              digits: this.props.boxNumber.scannedOrderIDOrderDetailsSuccess
                .orderId,
              loaderStatus: false,
            });
          }
        })
        .catch(() => {
          message.error("Something went wrong");
        });
    } else {
      // Get Box Number based on the Order Id that you've entered
      this.props
        .getOrderDetailsThunk({
          access_token: this.props.access_token,
          warehouseId: warehouseId,
          orderId: this.state.enteredId,
          history: this.props.history,
        })
        .then(() => {
          message.destroy();
          if (this.props.orderId.newOrderDetailsError) {
            this.setState({
              digits: null,
              loaderStatus: false,
            });
            message.error(this.props.orderId.newOrderDetailsError);
          } else {
            if (!this.props.orderId.newOrderDetailsSuccess.boxNumber) {
              message.error("No Box is assigned to this Order Id!", 2);
              this.setState({
                loaderStatus: false,
              });
              return;
            }
            this.setState({
              digits: this.props.orderId.newOrderDetailsSuccess.boxNumber,
              loaderStatus: false,
            });
          }
        })
        .catch(() => {
          message.error("Something went wrong");
        });
    }
  };
  render() {
    return (
      <div className="centerScreen">
        {this.props.isOnline ? (
          <MakerWrapper>
            <UserGreeting />
            <div style={{ marginTop: "25px" }}>
              <TitleWrapper title={"Box Number & Order Id Search"} />
              <div className="inputWrap">
                <OrderWrapper style={{ flexDirection: "column" }}>
                  <div className="inputWrap">
                    {/* Select the type of output you need */}
                    <Select
                      defaultValue={this.state.options[0]}
                      name="option"
                      style={{ width: "100%" }}
                      autoFocus
                      variant="outlined"
                      options={this.state.options}
                      onChange={(e) => {
                        this.setState({
                          selectedOption: e,
                          digits: null,
                          enteredId: null,
                        });
                      }}
                    />
                  </div>
                  <div className="inputWrap">
                    {/* Enter the Box or Order Number */}
                    <CustomField
                      placeholder={
                        this.state.selectedOption === "box_Id"
                          ? "Enter Order Id"
                          : "Enter the Box Number"
                      }
                      type={
                        this.state.selectedOption === "box_Id"
                          ? "number"
                          : "text"
                      }
                      variant="outlined"
                      name="enteredId"
                      label="enter Id"
                      value={this.state.enteredId}
                      onChange={(e) => {
                        this.setState({
                          enteredId: e.target.value,
                        });
                      }}
                      autoFocus
                      min={0}
                      ref={this.enteredId}
                    />
                  </div>
                  <div className="btnWrap">
                    <Button
                      type="submit"
                      onClick={() => this.detailsHandler()}
                      disabled={this.state.loaderStatus}
                    >
                      {this.state.loaderStatus ? (
                        <CircularProgress size={20} />
                      ) : (
                        "Search"
                      )}
                    </Button>
                  </div>
                  {/* This is where the Output is displayed */}
                  {this.state.digits ? (
                    <div
                      className="inputWrap"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <div className="" style={{ marginRight: "10px" }}>
                        {this.state.selectedOption === "box_Id"
                          ? "Box ID:"
                          : "Order ID :"}{" "}
                        {""}
                      </div>
                      <div>
                        <h5>{this.state.digits}</h5>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </OrderWrapper>
                <br />
              </div>
            </div>
          </MakerWrapper>
        ) : (
          <OfflinePage />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  isOnline: state.statusReducer?.isOnline,
  isLoading: state.LoaderReducer?.isLoading,
  boxNumber: state.scannerReducer,
  orderId: state.newOrderDetailsReducer,
});
export default withRouter(
  connect(mapStateToProps, {
    getOrderIDScanThunk,
    getOrderDetailsThunk,
  })(DisPacker)
);
